import React from "react";
import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'


const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <div className="container-fluid">
          <Row>
            <Col className="sm:w-6/12">{new Date().getFullYear()} © Skote.</Col>
            <Col className="sm:w-6/12">
              <div className="text-sm-right d-none d-sm-block">
                Design & Develop by Themesbrand
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
